import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Entity } from '../../../../entities/entity';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';

@MergeSchema({
    entity: ActivityEntityName.Contact
})
export class ContactFullMergeData {
    @MergeField()
    firstName: string;

    @MergeField()
    lastName: string;

    @MergeField()
    email: string;

    @MergeField()
    mobile: string;

    @MergeField()
    jobTitle: string;

    @MergeField({
        displayName: "Full name"
    })
    name: string;

    @MergeField({
        displayName: "Phone (home)"
    })
    phone: string;

    @MergeField({
        displayName: "Phone (work)"
    })
    workPhone: string;

    parents: Entity[]

    sites: Entity[]
}

export const ContactFullMergeSchema = getSchema(ContactFullMergeData);